import React from "react";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import { Button, Input, Box } from "@mui/joy";
import { LoaderWithText } from "../../shared/Loader";

type TEditTitleModalProps = {
	open: boolean;
	onClose: () => void;
	title: string;
	setTitle: (title: string) => void;
	onSave: () => void;
	loading: boolean;
	error: string | null;
};

const EditTitleModal: React.FC<TEditTitleModalProps> = ({
	open,
	onClose,
	title,
	setTitle,
	onSave,
	loading,
	error,
}) => {
	return (
		<Modal
			aria-labelledby="edit-title-modal-title"
			aria-describedby="edit-title-modal-description"
			open={open}
			onClose={onClose}
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<Sheet
				variant="outlined"
				sx={{
					width: 600,
					borderRadius: "md",
					p: 3,
					boxShadow: "lg",
				}}
			>
				<ModalClose
					variant="plain"
					sx={{ m: 1 }}
				/>
				<Typography
					component="h2"
					id="edit-title-modal-title"
					level="h4"
					textColor="inherit"
					fontWeight="lg"
					mb={1}
				>
					Edit Conversation Title
				</Typography>
				<Input
					type="text"
					value={title}
					onChange={(e) => setTitle(e.target.value)}
					className="title-input"
					sx={{ width: "100%", mb: 2 }}
				/>
				{error && (
					<Typography
						color="danger"
						level="body-sm"
						sx={{ mb: 2 }}
					>
						{error}
					</Typography>
				)}
				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						gap: 1,
					}}
				>
					<Button
						variant="outlined"
						color="neutral"
						onClick={onClose}
						disabled={loading}
					>
						Cancel
					</Button>
					<Button
						onClick={onSave}
						disabled={loading}
					>
						{loading ? (
							<LoaderWithText
								text="Saving..."
								loaderWidth="30"
							/>
						) : (
							"Save"
						)}
					</Button>
				</Box>
			</Sheet>
		</Modal>
	);
};

export default EditTitleModal;
